class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.menu = this.details.querySelector('ul');
    this.animations = this.menu.getAnimations ? this.menu.getAnimations() : [];
    this.closeTimeout = null;

    this.overlay = document.querySelector(".header-overlay");
    this.headerEl = document.querySelector(".header");

    [this.summary, this.menu].forEach(el => {
      if (!el) return;
      el.addEventListener('mouseenter', () => this.open());
      el.addEventListener('mouseleave', (e) => this.delayedClose(e));
    });
  }

  open() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.animations.forEach(a => a.play());

    if (this.overlay && this.headerEl) {
      this.overlay.hidden = false;
      this.headerEl.classList.add("opened");
      requestAnimationFrame(() => this.overlay.classList.add("active"));
    }
  }

  delayedClose(event) {
    const related = event.relatedTarget;
    this.closeTimeout = setTimeout(() => {
      if (!this.summary.contains(related) && !this.menu.contains(related)) {
        this.close();
      }
    }, 50);
  }

  close() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
    this.animations.forEach(a => a.cancel());

    if (this.overlay && this.headerEl) {
      this.overlay.classList.remove("active");
      this.headerEl.classList.remove("opened");
      this.overlay.addEventListener(
        "transitionend",
        () => this.overlay.hidden = true,
        { once: true }
      );
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.querySelector(".header-overlay");
  const megaMenus = document.querySelectorAll("header-menu");

  if (overlay) {
    overlay.addEventListener("click", () => {
      megaMenus.forEach(menu => menu.close());
    });
  }
});

customElements.define('header-menu', HeaderMenu);
